<template>
  <LayoutMaster>
    <div class="px-1" v-if="isDone">
      <div class="pb-10 border-b border-gray-800">
        <MovieShow :movies="comingSoon" title="upcoming Moives" ></MovieShow>
      </div>
    </div>
    <div  v-else>
      <div class="flex justify-center items-center min-h-screen pb-28 lg:pb-16">
        <img src="../assets/loading.gif" alt="loading" class="w-80">
      </div>
    </div>
  </LayoutMaster>
</template>

<script>
import axios from "axios";
import MovieShow from "@/components/MovieShow";
import LayoutMaster from "@/components/LayoutMaster";
export default {
  name: "ComingView",
  components: {MovieShow, LayoutMaster},
  data() {
    return {
      comingSoon: [],
      isDone: false,
    }
  },
  created() {
    let token= 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5Y2Q5ZDIzMWMyZWNmOWVlMjMwNTQ1MjY2MDA0NGU1YSIsInN1YiI6IjYyYWMxOGNiZDdjZDA2MDA5Mjk5ZTNiYSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.8aPeoTYZyUOuN72OyZbXh7gDcw6-RhwVJ4vIedUaeFo';
    axios.get(`https://api.themoviedb.org/3/movie/upcoming`,{
      headers: {"Authorization" : `Bearer ${token}`}
    })
        .then(res => this.comingSoon = res.data.results)
        .catch(error => console.log(error));

    setTimeout(() => {
      this.isDone = true;
    }, 2000);
  }
}
</script>

<style scoped>

</style>